import { Component } from '@angular/core'
import { EnvService } from '@envs/env-service'
import { FolderOverviewService } from '../store/services'
import { Title } from '@angular/platform-browser'

@Component({
  selector: 'folder-overview-retained-teams',
  templateUrl: './folder-overview-retained-teams.component.html',
  styleUrls: ['./folder-overview-retained-teams.component.scss'],
})
export class FolderOverviewRetainedTeamsComponent {
  get id(): number {
    return this.folderOverviewService.folderId
  }

  constructor(
    private envService: EnvService,
    private titleService: Title,
    private folderOverviewService: FolderOverviewService
  ) {
    this.titleService.setTitle('Folder Overview | Retained Teams')
  }

  public get baseJsUrl(): string {
    return `${this.envService.baseJsUrl}/folder-overview/${this.id}/sow-retained-teams?sow_id=${this.id}`
  }
}
